define('ShareCart.Cart.Line', [
    'sharecart_cart_line.tpl',
    'Backbone'
], function ShareCartCartLine(
    sharecartCartLineTpl,
    Backbone
) {
    'use strict';

    return Backbone.View.extend({
        template: sharecartCartLineTpl,
        initialize: function initialize(options) {
            this.model = options.model;
        },
        getContext: function getContext() {
            var item = this.model.get('item');
            return {
                quantity: this.model.get('quantity'),
                url: item.get('_url'),
                thumbnail: item.get('_thumbnail'),
                name: item.get('_name'),
                price: item.getPrice().price_formatted,
                internalid: item.get('internalid'),
                soldInStore: item.get('_soldInStore'),
                isPurchasable: item.get('_isPurchasable'),
                unavailabilityMessage: item.get('_notSoldInStoreMessage')
            };
        }
    });
});
